import React from 'react';

import { AttachedFilesStore } from '~/modules/attachedFiles/AttachedFilesStore';
import { AuthStore } from '~/modules/auth/AuthStore';
import { FileTypesStore } from '~/modules/fileTypes/FileTypesStore';
import { LangStore } from '~/modules/lang/LangStore';

class RootStore {
  langStore: LangStore;
  authStore: AuthStore;

  fileTypesStore: FileTypesStore;
  attachedFilesStore: AttachedFilesStore;

  constructor() {
    this.langStore = new LangStore();
    this.authStore = new AuthStore();

    this.fileTypesStore = new FileTypesStore();
    this.attachedFilesStore = new AttachedFilesStore();
  }

  init = async () => {
    await Promise.all(
      Object.values(this).map((store) => {
        return store?.init ? store?.init() : Promise.resolve();
      }),
    );
  };

  reset = async () => {
    await Promise.all(
      Object.values(this).map((store) => {
        return store.reset ? store.reset() : Promise.resolve();
      }),
    );
  };
}

export const rootStore = new RootStore();

export const storesContext = React.createContext(rootStore);
